export const customerInitalState = {
  paymentNonce: null,
};
